/**
 * <Header />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'

const DEFAULT_USE_DEFAULT_CLOSE_BUTTON = true;
const DEFAULT_HEADER_TYPE = "default";

class Header extends React.Component {
  constructor(props) {
		super(props);
	}

	render() {
		let {
			closeModal,
			headerIcon,
			headerTitle,
			headerType,
			headerClassName,
			useDefaultCloseButton,
			headerCustomContent,
		} = this.props;

		if (typeof useDefaultCloseButton === "undefined") {
			useDefaultCloseButton = DEFAULT_USE_DEFAULT_CLOSE_BUTTON;
		}

		return (
			<div className={classnames("header", headerClassName, "header-type-" + (headerType || DEFAULT_HEADER_TYPE) )}>
				{ headerIcon && <div className="header-icon"><i className={headerIcon}></i></div> }
				{ headerTitle && <div className="header-title">{headerTitle}</div>}
				{ headerCustomContent && <div className='header-custom-content'>{headerCustomContent}</div> }
				{ useDefaultCloseButton != false && (
					<div className='close-button' onClick={closeModal}>
						<i className='fa icon-cancel'></i>
					</div>
					)
				}
      </div>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/Header.js